/* global axios */
import ApiClient from './ApiClient';

class BillingAPI extends ApiClient {
  constructor() {
    super('billing', { accountScoped: true });
  }

  // Get billing info (subscription, addons, limits, usage)
  getBillingInfo() {
    return axios.get(this.url);
  }

  // Get available subscription plans
  getPlans() {
    return axios.get(`${this.url}/plans`);
  }

  // Get available addons
  getAvailableAddons() {
    return axios.get(`${this.url}/addons`);
  }

  // Get available payment methods (Stripe, Asaas PIX, Asaas Boleto, etc.)
  getPaymentMethods() {
    return axios.get(`${this.url}/payment_methods`);
  }

  // Create checkout session
  // paymentMethod: 'stripe' | 'asaas_credit_card' | 'asaas_pix' | 'asaas_boleto'
  checkout(params = {}) {
    return axios.post(`${this.url}/checkout`, params);
  }

  // Get billing portal URL
  getPortalUrl(returnUrl) {
    return axios.post(`${this.url}/portal`, { return_url: returnUrl });
  }

  // Change subscription plan
  changePlan(planId, billingCycle = 'monthly') {
    return axios.post(`${this.url}/change_plan`, {
      plan_id: planId,
      billing_cycle: billingCycle,
    });
  }

  // Cancel subscription
  cancelSubscription(immediately = false) {
    return axios.post(`${this.url}/cancel`, { immediately });
  }

  // Add addon to account
  // paymentMethod: 'stripe' | 'asaas_credit_card' | 'asaas_pix' | 'asaas_boleto'
  addAddon(
    addonId,
    quantity = 1,
    billingCycle = 'monthly',
    paymentMethod = null
  ) {
    return axios.post(`${this.url}/add_addon`, {
      addon_id: addonId,
      quantity,
      billing_cycle: billingCycle,
      payment_method: paymentMethod,
    });
  }

  // Remove addon from account
  removeAddon(accountAddonId) {
    return axios.delete(`${this.url}/addons/${accountAddonId}`);
  }

  // Get support contact info (email, whatsapp, inbox_id)
  getSupportInfo() {
    return axios.get(`${this.url}/support_info`);
  }

  // Get billing details (CPF/CNPJ, billing address, etc.)
  getBillingDetails() {
    return axios.get(`${this.url}/billing_details`);
  }

  // Update billing details (CPF/CNPJ, billing address, etc.)
  updateBillingDetails(params = {}) {
    return axios.put(`${this.url}/billing_details`, params);
  }

  // Check payment status (for PIX/Boleto polling)
  // paymentId is optional - if provided, checks that specific payment directly
  getPaymentStatus(paymentId = null) {
    const params = paymentId ? { payment_id: paymentId } : {};
    return axios.get(`${this.url}/payment_status`, { params });
  }
}

export default new BillingAPI();
